import axios from 'axios';
import type { INotificationSettings } from '@bb/domain/dist/types';

const saveNotificationSettings = async (settings: INotificationSettings) => axios.post('/user/current/notifications', settings);

export default saveNotificationSettings;
